/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import format from 'date-fns/format';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import { Panel } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import LineChart from 'loracoms/LineChart';
import appActions from 'loraactions/app';
import dashboardActions from 'loraactions/dashboard';
import callAPI from '@/api/callAPI';
import loadingImg from 'loraimages/chart_loading.gif';
import styles from './styles.scss';

const kChartHeight = 200;

const propTypes = {
  intl: PropTypes.object.isRequired,
  deveuis: PropTypes.array.isRequired,
  dps: PropTypes.array.isRequired,
  dpsShow: PropTypes.array.isRequired,
  // gridTop: PropTypes.string.isRequired,
  time: PropTypes.object.isRequired,
  dashboardState: PropTypes.object.isRequired,
  appState: PropTypes.object.isRequired,
  refreshState: PropTypes.number.isRequired,
  getDashboard: PropTypes.func.isRequired,
  getApp: PropTypes.func.isRequired,
  dashId: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired,
  showPanel: PropTypes.bool,
};

const defaultProps = {
  showPanel: true,
};

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
    this.state = {
      series: [],
      categories: ['11', '12', '13', '14', '15', '16', '17'],
      deveuis: props.deveuis,
      dps: props.dps,
      dpsShow: props.dpsShow,
      // gridTop: props.gridTop,
      status: 'pending',
      loadStatus: 'pending',
      time: props.time,
      appState: props.appState,
      dashboardState: props.dashboardState,
      showPanel: props.showPanel,
      allDpsdata: [],
      dpsStats: [],
      statSeries: {
        drops: {
          name: 'drops', // this.intlMsg.msg('map.drops')
          data: [],
          yAxisIndex: 0,
        },
        snr: {
          name: 'snr',
          data: [],
          yAxisIndex: 0,
        },
        rssi: {
          name: 'rssi',
          data: [],
          yAxisIndex: 0,
        },
        categories: [],
      },
    };
    this.showTo = null;
    this.showFrom = null;
  }

  componentWillMount() {
    const { getDashboard, dashId, getApp, appId, showPanel } = this.props;
    const { dashboardState: { data }, appState } = this.state;
    this.loadDps();
    if (!data) {
      getDashboard(dashId);
    }
    this.handleData();
    if (!appState.data) {
      getApp(appId);
    }
    this.setState({ showPanel });
  }

  componentWillReceiveProps(nextProps) {
    const {
      deveuis,
      dps,
      time,
      refreshState,
      dashboardState,
      appState,
      dpsShow,
      // gridTop,
    } = nextProps;
    if (deveuis !== this.props.deveuis) {
      this.setState({ deveuis }, () => {
        this.handleData();
      });
    }
    if (dps !== this.props.dps) {
      this.setState({ dps });
    }
    if (dpsShow !== this.props.dpsShow) {
      this.setState({ dpsShow });
    }
    // if (gridTop !== this.props.gridTop) {
    //   this.setState({ gridTop });
    // }
    if (time !== this.props.time) {
      this.setState({ time }, () => {
        this.handleData();
      });
    }
    if ((refreshState !== this.props.refreshState) && refreshState !== 0) {
      this.handleData('success');
    }
    if (dashboardState !== this.props.dashboardState) {
      this.setState({ dashboardState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  // judgeDps(d) {
  //   return (d === 'snr' || d === 'rssi' || d === 'drops');
  // }

  loadDps() {
    const { appId } = this.props;
    callAPI({
      endpoint: '/lora/dps',
      query: {
        appid: appId,
      },
    }).then((data) => {
      this.setState({
        allDpsdata: data.list,
      });
    }).catch(() => {});
  }

  loadData(item, dps, stat) {
    const { time: { from } } = this.state;
    const to = stat ? new Date() : this.state.time.to;
    return callAPI({ endpoint: '/lora/timeseries',
      method: 'POST',
      body: { nodeid: item, dps, from, to, limit: 10000 },
    });
  }

  loadStats(d) {
    const { deveuis } = this.state;
    let { dpsStats } = this.state;
    // dpsStats = _.difference(dpsStats, [d]);
    dpsStats.push(d);
    dpsStats = _.uniq(dpsStats);

    this.setState({ dpsStats });

    callAPI({
      endpoint: `/lora/nodes/${deveuis[0]}/rxqos?download`,
    }).then((data) => {
      const drops = [];
      const snr = [];
      const rssi = [];
      const slots = [];
      this.showTo = format(data.list[0].$time, 'MM-DD HH:mm:ss');
      this.showFrom = format(data.list[data.list.length - 1].$time, 'MM-DD HH:mm:ss');
      data.list.reverse().forEach((item) => {
        slots.push(format(item.$time, 'MM-DD HH:mm:ss'));
        drops.push(item.drops);
        snr.push(item.lorasnr);
        rssi.push(item.rssi);
      });
      const { statSeries } = this.state;
      statSeries.drops.data = drops;
      statSeries.snr.data = snr;
      statSeries.rssi.data = rssi;
      statSeries.categories = slots;
      this.setState({ statSeries, loadStatus: 'success' });
    });
  }

  handleData(stat) {
    this.setState({ status: stat || 'pending', loadStatus: 'pending' });
    const { dps, deveuis } = this.state;
    const categories = [];
    let seriesAll = [];
    let promises;
    if (dps.length === 1) {
      if (dps[0] === 'snr' || dps[0] === 'rssi' || dps[0] === 'drops') {
        this.loadStats(dps[0]);
      }
    } else {
      _.map(dps, (d) => {
        if (d === 'snr' || d === 'rssi' || d === 'drops') {
          this.loadStats(d);
        }
      });
    }
    promises = _.map(deveuis, (item) => {
      if (dps.length === 1) {
        return (
          this.loadData(item, dps, stat).then((res) => {
            const data = Object.assign({}, res, { deveui: item }, { dps: dps[0] });
            return data;
          }).catch(() => {
          })
        );
      }
      return _.map(dps, d => (
        this.loadData(item, [d], stat).then((res) => {
          const data = Object.assign({}, res, { deveui: item }, { dps: d });
          return data;
        }).catch(() => {
        })
      ));
    });

    if (!_.isArray(promises[0])) {
      Promise.all(promises).then((res) => {
        let status = 'empty';
        seriesAll = _.map(res, (item) => {
          const list = item.list.reverse();
          if (item.list.length !== 0) {
            status = 'success';
          }
          const data = _.map(list, (l) => {
            categories.push(format(l.timestamp, 'DD/MM HH:mm:ss'));
            return l.metrics[item.dps];
          });
          return { name: item.dps, yAxisIndex: 0, data, areaStyle: { normal: { opacity: 0.1 } } };
        });
        this.setState({ series: seriesAll, categories, status });
      });
    } else if (_.isArray(promises[0])) {
      const promlength = promises[0].length - 1;
      _.map(promises[0], (prom, idx) => {
        promises = [prom];
        Promise.all(promises).then((res) => {
          let status = 'empty';
          const seriesSingle = _.map(res, (item) => {
            const list = item.list.reverse();
            if (item.list.length !== 0) {
              status = 'success';
            }
            const data = _.map(list, (l) => {
              if (idx === promlength) {
                categories.push(format(l.timestamp, 'DD/MM HH:mm:ss'));
              }
              return l.metrics[item.dps];
            });
            return {
              name: item.dps,
              yAxisIndex: 0,
              data,
              areaStyle: { normal: { opacity: 0.1 } },
            };
          });
          seriesAll.push(seriesSingle[0]);
          if (idx === promlength) {
            this.setState({ series: seriesAll, categories });
            this.setState({ status });
          }
        });
      });
    }
  }

  renderHeader() {
    const {
      dashboardState: { data: { id } },
      appState: { data: { appeui } },
      showPanel,
    } = this.state;
    const { time: { from, to } } = this.props;
    if (!showPanel) {
      return null;
    }
    return (
      <div className={`clearfix ${styles.header} text-center`}>
        <div className={styles.chartName}>
          <p className={styles.fontM}>
            {this.showFrom || format(from, 'YYYY-MM-DD HH:mm:ss')}&nbsp;——&nbsp;
            {this.showTo || format(to, 'YYYY-MM-DD HH:mm:ss')}
          </p>
        </div>
        <Link
          className={`fa fa-compress ${styles.compress}`}
          to={`/application/${appeui}/dashboard/basic/${id}`}
        />
        <span className={styles.triangle} />
      </div>
    );
  }

  render() {
    const {
      loadStatus,
      statSeries,
      dpsStats,
      dpsShow,
      dps,
      // gridTop,
      allDpsdata,
    } = this.state;
    let { series, categories, status } = this.state;
    if (status === 'empty') {
      if (loadStatus === 'success') {
        categories = statSeries.categories;
        const staData = [];
        _.map(dpsStats, (d) => {
          if (statSeries[d].data === []) {
            staData.push(statSeries[d]);
          }
          // series = _.difference(series, [statSeries[d]]);
          series.push(statSeries[d]);
          series = _.uniqWith(series, _.isEqual);
        });
        if (staData.length === dpsStats.length) {
          status = 'empty';
        } else {
          status = 'success';
        }
      }
    }
    let content;
    if (status === 'pending') {
      content = <img src={loadingImg} alt="" />;
    } else if (status === 'success') {
      _.map(dpsShow, (d, idx) => {
        _.map(d.data, (da, idxd) => {
          _.map(allDpsdata, (a) => {
            if (da === a.id) {
              if (a.desc !== '') {
                dpsShow[idx].data[idxd] = a.desc;
              } else {
                dpsShow[idx].data[idxd] = a.id;
              }
            }
          });
        });
      });
      _.map(series, (s, idx) => {
        _.map(allDpsdata, (a) => {
          if (s.name === a.id) {
            if (a.desc !== '') {
              series[idx].name = a.desc;
            } else {
              series[idx].name = a.id;
            }
          }
        });
      });
      content = (
        <LineChart
          yAxis={[{
            name: '',
            splitNumber: 5,
          }]}
          legend={dpsShow}
          series={series}
          categories={categories}
          dataZoom={[{
            type: 'slider',
            fillerColor: 'rgba(228, 241, 254, 0.4)',
            dataBackground: {
              lineStyle: { width: 0 },
              areaStyle: { color: 'rgba(107, 185, 240, 0.8)' },
            },
          }]}
          grid={{
            top: 30,
            left: 60,
            right: 30,
            bottom: 60,
          }}
          height={kChartHeight}
          animation
        />
      );
    }
    // else if (this.judgeDps() && loadStatus === 'success') {
    //   // && status === 'success'
    //   let dpsName;
    //   _.map(allDpsdata, (a) => {
    //     if (a.id === dps[0]) {
    //       if (a.desc !== '') {
    //         dpsName = a.desc;
    //       } else {
    //         dpsName = dps[0];
    //       }
    //     }
    //   });
    //   content = (
    //     <LineChart
    //       yAxis={[
    //         {
    //           name: dpsName,
    //           splitNumber: 5,
    //         },
    //       ]}
    //       xAxis={{
    //         axisTick: { alignWithLabel: true },
    //         boundaryGap: true,
    //       }}
    //       legend={{
    //         data: dps,
    //       }}
    //       series={[statSeries[dps[0]]]}
    //       categories={statSeries.categories}
    //       dataZoom={[{
    //         type: 'slider',
    //         fillerColor: 'rgba(228, 241, 254, 0.4)',
    //         dataBackground: {
    //           lineStyle: { width: 0 },
    //           areaStyle: { color: 'rgba(107, 185, 240, 0.8)' },
    //         },
    //       }]}
    //       tooltip={{
    //         formatter: (params) => {
    //           const dataLines = params.map(p =>
    //            `<span style="display: inline-block; background: ${p.color}; width: 9px; height: 9px; border-radius: 100%;"></span> ${p.seriesName} : ${_.isNil(p.value) ? '-' : Number(p.value).toFixed(1)}`).join('<br />');
    //           return `${params[0].name}<br />${dataLines}`;
    //         },
    //       }}
    //       grid={{
    //         left: 60,
    //         top: 30,
    //         right: 30,
    //         bottom: 60,
    //       }}
    //       colorShift={2}
    //       height={200}
    //       resize
    //     />
    //   );
    // }
    else if (status === 'empty') {
      let dpsName = [];
      if (dps.length === 1) {
        dpsName = dps[0];
      } else {
        _.map(dps, (d) => {
          dpsName = _.concat(dpsName, d);
        });
        dpsName = _.join(dpsName, ' , ');
      }
      content = (
        <div>
          <span>{dpsName}</span>
          <div styleName="noData">{this.intlMsg.msg('chart.nodata')}</div>
        </div>
      );
    }
    return (
      <Panel
        bsStyle="aisz-white"
        header={this.renderHeader()}
        styleName="clear-panel"
      >
        <div styleName="chart-preview">
          <div styleName="graph">
            {content}
          </div>
        </div>
      </Panel>
    );
  }
}

Chart.propTypes = propTypes;
Chart.defaultProps = defaultProps;

const mapStateToProps = state => ({
  time: state.dashboard.getTimes,
  deveuis: state.dashboard.getDeveui,
  appState: state.app.getApp,
  refreshState: state.dashboard.getRefreshCount,
  dashboardState: state.dashboard.getDashboard,
});

const mapDispatchToProps = {
  getDashboard: dashboardActions.getDashboard,
  getApp: appActions.getApp,
};

export default connect(mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(Chart,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/Chart/index.jsx